import { Base64DecodePipe } from 'app/shared/pipes/base64-decode.pipe';

export interface NotificationTemplateInterface {
  id?:number;
  title?:string;
  templateText?:string;
}

export class NotificationTemplate implements NotificationTemplateInterface {
  public id?: number;
  public title?: string;
  public templateText?: string;

  constructor({
        id = undefined,
        title = undefined,
        templateText = undefined,
    }: NotificationTemplateInterface) {
    this.id = id;
    this.title = title;
    this.templateText = templateText;
  }

  public textAsHtml(): string {
    return new Base64DecodePipe().transform(this.templateText);
  }
}
